import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';

const AuthCallback: React.FC = () => {
  const { checkAuthStatus } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Check if there's an authorization code from Auth0
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        console.log('AuthCallback - code:', code, 'error:', error);

        if (error) {
          console.error('Auth0 error:', error);
          // Redirect back to login
          navigate('/login');
          return;
        }

        if (code) {
          // Auth0 code received, let the AuthContext handle it
          console.log('✅ Auth0 code received:', code);
          await checkAuthStatus();
          // The AuthContext will handle the redirect to /dummy
        } else {
          // No code, redirect to login
          console.log('❌ No code received, redirecting to login');
          navigate('/login');
        }
      } catch (error) {
        console.error('Callback handling error:', error);
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, checkAuthStatus, navigate]);

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)'
    }}>
      <CircularProgress size={60} sx={{ color: 'white', mb: 2 }} />
      <Typography variant="h6" sx={{ color: 'white', mb: 2 }}>
        Processing Authentication...
      </Typography>
      <Typography variant="body2" sx={{ color: 'white', opacity: 0.8 }}>
        Please wait while we complete your login
      </Typography>
      
      {/* Debug information */}
      <Box sx={{ mt: 4, p: 2, bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 1, maxWidth: 400 }}>
        <Typography variant="caption" sx={{ color: 'white', display: 'block' }}>
          Debug Info:
        </Typography>
        <Typography variant="caption" sx={{ color: 'white', display: 'block' }}>
          URL: {window.location.href}
        </Typography>
        <Typography variant="caption" sx={{ color: 'white', display: 'block' }}>
          Code: {searchParams.get('code') || 'none'}
        </Typography>
        <Typography variant="caption" sx={{ color: 'white', display: 'block' }}>
          Error: {searchParams.get('error') || 'none'}
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthCallback;
